import FlashService from '~/services/flash/FlashService'

export default function({ $dep }: any) {
  const flashService = $dep(FlashService)

  flashService.setBackendFlashFromCookie()
}
